import { NovaUnifiedPageBar, novaContextPillFromRaw } from '../NovaUnified';

/**
 * Nova check-in banner for chapter home pages — unified Nova block (demo + product).
 */
export default function NovaCheckIn({ context, message, onOpenNova, theme: _theme, chapter: _chapter }) {
  return (
    <NovaUnifiedPageBar
      layout="stacked"
      contextPill={novaContextPillFromRaw(context)}
      body={message}
      actionLabel="Open Nova →"
      onAction={onOpenNova}
    />
  );
}
